import React from "react";

const TOOLS = [
    { cmd: "bold", icon: "bi-type-bold", title: "Bold" },
    { cmd: "italic", icon: "bi-type-italic", title: "Italic" },
    { cmd: "underline", icon: "bi-type-underline", title: "Underline" },
    { cmd: "insertUnorderedList", icon: "bi-list-ul", title: "Bullet list" },
    { cmd: "insertOrderedList", icon: "bi-list-ol", title: "Numbered list" },
];

export default function RichTextToolbar({ editorRef, className = "" }) {
    const apply = (command) => {
        if (!editorRef?.current) return;
        editorRef.current.focus();
        document.execCommand(command, false, null);
    };

    return (
        <div className={`crm-rich-toolbar ${className}`.trim()}>
            {TOOLS.map((tool) => (
                <button
                    key={tool.cmd}
                    type="button"
                    title={tool.title}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={() => apply(tool.cmd)}
                >
                    <i className={`bi ${tool.icon}`}></i>
                </button>
            ))}
        </div>
    );
}

export function RichTextEditor({ editorRef, placeholder, className = "" }) {
    return (
        <div
            ref={editorRef}
            className={`crm-rich-editor ${className}`.trim()}
            contentEditable
            suppressContentEditableWarning
            data-placeholder={placeholder || "Write your message..."}
        />
    );
}
